import{EBANKINGWEBUK,EBANKINGWEBLUX,EBANKINGWEB} from '../../src/constants';
import { envConfig } from '../../db-env-build';
export default function getRegionName() {
   switch(envConfig){
    case EBANKINGWEB: 
    return 'Switzerland';
    case EBANKINGWEBLUX: 
    return 'Luxembourg';
    case EBANKINGWEBUK:
    return 'UK';
    default:
    return '';
   }
 }

   